import { Link, useRouteError } from 'react-router';
import { PageShell } from './PageShell';
import { Button } from './ui/Button';

export function NotFoundPage() {
  return (
    <PageShell className="pt-20 text-center">
      <p className="font-display text-8xl font-black text-primary-500">404</p>
      <h1 className="mt-2 font-display text-3xl font-extrabold">Ok… where?</h1>
      <p className="mt-2 text-ink-300">Even we couldn't place this page on the map.</p>
      <Link to="/" className="mt-8 inline-block">
        <Button>Take me home</Button>
      </Link>
    </PageShell>
  );
}

export function CrashPage() {
  const error = useRouteError();
  return (
    <PageShell className="pt-20 text-center">
      <p className="text-5xl">💥</p>
      <h1 className="mt-4 font-display text-3xl font-extrabold">Something broke</h1>
      <p className="mx-auto mt-2 max-w-md text-ink-300">
        {error instanceof Error ? error.message : 'An unexpected error happened.'}
      </p>
      <Button className="mt-8" onClick={() => window.location.assign('/')}>
        Reload
      </Button>
    </PageShell>
  );
}
